import React from 'react';
import { BreadcrumbProps } from '@aidkitorg/component-library';
import { useLocalizedStrings } from '../../Localization';
import { AdminPanelPage } from '../AdminPanelPage';

export const ImportApplicantsPage: React.FC = () => {
  const L = useLocalizedStrings();

  const breadcrumbs: BreadcrumbProps['items'] = [
    {
      label: L.admin_panel.nav.applicants,
      href: "/admin-panel/applicants/all"
    },
    {
      label: L.admin_panel.nav.all_applicants,
      href: "/admin-panel/applicants/all"
    },
    {
      label: L.admin_panel.applicants.all_applicants.import.breadcrumb
    }
  ];

  return (
    <AdminPanelPage
      title={L.admin_panel.applicants.all_applicants.import.title}
      description={L.admin_panel.applicants.all_applicants.import.description}
      breadcrumbs={breadcrumbs}
    >
    </AdminPanelPage>
  );
};

export default ImportApplicantsPage;
